import globalTranslations from './global.mjs';
import accountingTranslations from './accounting.mjs';
import cookiesBarTranslations from './cookiesBar.mjs';
import emailsTranslations from './emails.mjs';
import machineKeysTranslations from './machineKeys.mjs';
import permissionsTranslations from './permissions.mjs';
import questionsEditorTranslations from './questionsEditor.mjs';
import sitesTranslations from './sites.mjs';
import translationsEditorTranslations from './translationsEditor.mjs';
import validationTranslations from './validation.mjs';

/**
 * Default english translations template, comprised of individual modules.
 */
export default {
  GLOBAL: globalTranslations,
  ACCOUNTING: accountingTranslations,
  COOKIES_BAR: cookiesBarTranslations,
  EMAILS: emailsTranslations,
  MACHINE_KEYS: machineKeysTranslations,
  PERMISSIONS: permissionsTranslations,
  QUESTIONS_EDITOR: questionsEditorTranslations,
  SITES: sitesTranslations,
  TRANSLATIONS_EDITOR: translationsEditorTranslations,
  VALIDATION: validationTranslations,
};
